import clsx from 'clsx';
import React from 'react';
import styles from './select.module.css';

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
    label?: string;
    error?: boolean;
    helperText?: string;
    className?: string;
}

const Select = React.forwardRef(
    (props: Props, ref: React.LegacyRef<HTMLSelectElement> | undefined) => {
        const { label, error, helperText, className, ...elementProps } = props;
        return (
            <div className="grid gap-2 my-3">
                {label && (
                    <label
                        className="block uppercase tracking-wide text-xs font-semibold"
                        htmlFor={elementProps.id}
                    >
                        {label}
                        {props.required && (
                            <span className="text-red-600 text-xs"> *</span>
                        )}
                    </label>
                )}
                <select
                    className={clsx(
                        styles.select,
                        error && styles['error-select'],
                        className && className,
                    )}
                    ref={ref}
                    {...elementProps}
                />
                {helperText && (
                    <p
                        className={`${
                            error ? 'text-red-500' : 'text-gray-600'
                        } text-xs italic`}
                    >
                        {helperText}
                    </p>
                )}
            </div>
        );
    },
);

export default Select;
